import { createApiActions } from '@ackee/redux-utils';
import { actionType } from '../../../services/utils';
const ACTION_TYPE_PREFIX = actionType('FETCH_USER');
export const fetchUser = createApiActions(ACTION_TYPE_PREFIX);